import { Fragment } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import OneTimeMission from "./onetime-mission";
import { FloatingLeftButton } from "@/components/FloatingLeftButton";
import { generateTextShadow } from "@/lib/utils";
import { useTranslation } from "@/lib/hooks/useTranslation";

export const Route = createFileRoute("/(game)/missions/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className="relative flex flex-col h-full bg-[#1D2A52]">
        <FloatingLeftButton
          onClick={() => navigate({ to: "/home" })}
          className="absolute left-0 top-4 z-50"
          icon={
            <svg
              className="w-4 h-4"
              viewBox="0 0 9 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 1V0H2V1H1V2H0V3H1V4H2V5H3V4H6V7H3V8H7V7H8V6H9V3H8V2H7V1H3Z"
                fill="white"
              />
            </svg>
          }
        />
        {/* Header */}
        <div className="w-full px-2 pt-2 pb-6 mb-2 border-0 flex flex-col items-center mt-6 border-b-4 border-[#0659B5]">
          <span
            className="text-white font-black text-2xl text-center"
            style={{
              textShadow: generateTextShadow(1.5),
            }}
          >
            {t("missions.title")}
          </span>
        </div>
        <OneTimeMission />
      </div>
    </Fragment>
  );
}
